import { Badge } from '@/components/ui/badge';

const STYLES = {
  received: 'bg-secondary text-primary',
  confirmed: 'bg-leaf/15 text-leaf',
  shipped: 'bg-accent/20 text-accent-foreground',
  delivered: 'bg-primary text-primary-foreground',
  cancelled: 'bg-destructive/10 text-destructive',
};

export const OrderStatusBadge = ({ status }) => (
  <Badge className={`border-0 capitalize ${STYLES[status] || 'bg-secondary text-primary'}`} data-testid={`order-status-${status}`}>
    {status}
  </Badge>
);

export default OrderStatusBadge;
